// src/contexts/AuthContext.js
import React, { createContext, useContext, useState } from 'react';

// Контекст авторизации
const AuthContext = createContext();

// Хук для удобного доступа к контексту
export const useAuth = () => useContext(AuthContext);

// Компонент-провайдер для оборачивания приложения
export const AuthProvider = ({ children }) => {
  // Инициализация состояния пользователя из localStorage
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  /**
   * Функция логина
   * @param {{ accessToken: string, refreshToken: string, userId: string }} data
   */
  const login = ({ accessToken, refreshToken, userId }) => {
    const u = { id: userId, accessToken, refreshToken };
    setUser(u);
    localStorage.setItem('user', JSON.stringify(u));
    console.log('User logged in and stored:', u);
  };

  /**
   * Функция логаута
   */
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    console.log('User logged out');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
